import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { getFormattedDollarDifference } from 'helpers/formattedDollar';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';

function CartOrderMinimumAlert({ min_order_amount, subtotal }) {
  const hasReachedOrderMinimum =
    !!min_order_amount && min_order_amount > subtotal;

  if (!hasReachedOrderMinimum) {
    return null;
  }

  const amountFromMinimum = getFormattedDollarDifference(
    min_order_amount,
    subtotal
  );

  return (
    <Box mb={2.5}>
      <StyledTypographyColorSectionNavLinkMain variant="caption">
        {`Add $${amountFromMinimum} to reach the minimum of $${min_order_amount}.`}
      </StyledTypographyColorSectionNavLinkMain>
    </Box>
  );
}

CartOrderMinimumAlert.propTypes = {
  min_order_amount: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired
};

export default CartOrderMinimumAlert;
